<template>
  <div class="l-notifications">
    <transition-group
      tag="div"
      class="l-notifications__wrapper"
      name="notifications-list">
      <v-alert
        v-for="notify in notifications"
        :key="notify.id"
        :icon="false"
        :type="notify.type"
        @click="removeNotify(notify.id)">
        {{ notify.message }}
      </v-alert>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'LNotifications',
  data() {
    return {
      notifications: [],
    };
  },
  created() {
    this.$eventBus.$on('notify', config => {
      const customId = +new Date();
      this.notifications.push({
        id: customId,
        type: config.type,
        message: config.message,
        timer: this.addNotifyTimer(customId),
      });
    });
  },
  methods: {
    addNotifyTimer(id) {
      return setTimeout(() => this.removeNotify(id), 4000);
    },
    removeNotify(id) {
      const notifyIndex = this.notifications.findIndex(notify => notify.id === id);
      if (~notifyIndex) {
        clearTimeout(this.notifications[notifyIndex].timer);
        this.notifications.splice(notifyIndex, 1);
      }
    },
  },
};
</script>

<style lang="scss">
  @import "src/assets/style/layouts/LNotifications";
</style>
